import yup, { textMessage } from '../../utils/yup'

export const noteSchema = yup.object().shape({
  message: textMessage(yup),
})
